// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__CmrRD","header-select":"SelectProduct_header-select__8E1GR"};